import { render, staticRenderFns } from "./LinkActivities.vue?vue&type=template&id=6d7ad51d&"
import script from "./LinkActivities.vue?vue&type=script&lang=ts&"
export * from "./LinkActivities.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports